import Image from "next/image";
import Link from "next/link";
import React from "react";

const ReservationButton = ({ dataHeader }) => {
  const reservationUrl = dataHeader?.reservation?.url || "";
  const reservationTitle =
    dataHeader?.reservation?.baslik || "Rezervasyonlarım";

  return (
    <Link
      href={reservationUrl}
      prefetch={false}
      className="flex items-center justify-center lg:py-2.5 py-1 lg:px-4 px-2.5 lg:gap-2.5 gap-1.5 rounded-[36px] bg-themebgColor transition-all ease-in-out duration-200 hover:bg-opacity-80"
    >
      <Image
        src="/icons/ticket.svg"
        className="block"
        alt="ticket"
        width={16}
        height={16}
      />
      <span className="text-white text-xs font-normal leading-normal">
        {reservationTitle}
      </span>
    </Link>
  );
};

export default ReservationButton;
